export default __webpack_public_path__ + "static/media/07.bbc84ed5.mp3";